import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import { AuthGuard } from './components/Auth/AuthGuard';
import Layout from './components/Layout/Layout';
import AgencyLayout from './components/Layout/AgencyLayout';
import Dashboard from './pages/Dashboard';
import Tasks from './pages/Tasks';
import TaskLog from './pages/TaskLog';
import Agencies from './pages/Agencies';
import ClientDetail from './pages/ClientDetail';
import TicketDetail from './pages/TicketDetail';
import AgencyPortal from './pages/AgencyPortal';
import Settings from './pages/Settings';
import Login from './pages/Login';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />

      <Route path="/portal/:agencyId" element={<AgencyLayout />}>
        <Route index element={<AgencyPortal />} />
        <Route path="task-log" element={<TaskLog isAgency={true} />} />
        <Route path="client/:id" element={<ClientDetail isAgency={true} />} />
        <Route path="task/:id" element={<TicketDetail isAgency={true} />} />
      </Route>

      <Route path="/" element={<AuthGuard><Layout /></AuthGuard>}>
        <Route index element={<Dashboard />} />
        <Route path="tasks" element={<Tasks />} />
        <Route path="task-log" element={<TaskLog />} />
        <Route path="tasks/:id" element={<TicketDetail />} />
        <Route path="agencies" element={<Agencies />} />
        <Route path="client/:id" element={<ClientDetail />} />
        <Route path="settings" element={<Settings />} />
      </Route>
    </Routes>
  );
};

function App() {
  return (
    <AppProvider>
      <Router>
        <AppRoutes />
      </Router>
    </AppProvider>
  );
}

export default App;